import axiosInstance from '@/services/axiosInstance'

async function updateAdministrativeCenter (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: '/api/sociedad/updateCentroAdministrativo',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { updateAdministrativeCenter }
